import { useMemo } from 'react';

import { useApplicationContext } from '@/app/shared/context/ApplicationContext';

import { type AdfoxServerData } from '@/packages/adfox/types/AdfoxContextData';

import { type PParams } from '../../types';

export function useAdfoxParameters(adfox: AdfoxServerData, pParams: PParams): Record<string, string> {
  const {
    custom: { isQaTestMode },
  } = useApplicationContext();

  return useMemo<Record<string, string>>(() => {
    const adfoxParams: Record<string, string> = { ...pParams, ...adfox.params };

    if (isQaTestMode) {
      adfoxParams.puid32 = 'test';
    }

    return adfoxParams;
  }, [isQaTestMode, pParams, adfox.params]);
}
